import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  TIME_LOCATION_PIN,
  WEATHER_TEMPERATURE,
  TRAVEL_AIRPLANE_UP_RIGHT,
  MISC_SUNGLASSES,
} from '@bwoty-web/styleguide';
import PreferenceOption from '../preferenceOption/preferenceOption';
import { destinationTraits, filterStepsTypes } from '../../appSettings';
import './preferencePicker.scss';


const preferenceOptions = {
  [destinationTraits.LOCATION]: {
    iconPath: TIME_LOCATION_PIN,
  },
  [destinationTraits.TEMPERATURE]: {
    iconPath: WEATHER_TEMPERATURE,
  },
  [destinationTraits.FLIGHT_TIME]: {
    iconPath: TRAVEL_AIRPLANE_UP_RIGHT,
  },
  [destinationTraits.SURPRISE]: {
    iconPath: MISC_SUNGLASSES,
  },
}

const PreferencePicker = ({ selected, onSelect, labels }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const onSelectOption = (optionKey) =>  {
    onSelect(optionKey);
    // if in filterflow => move to details directly on selection
    // so the user doesn't have to click the next-button as well
    if (location.pathname === `/${filterStepsTypes.DESTINATION_TRAITS_SELECTION}`) {
      navigate(`/${filterStepsTypes.DESTINATION_TRAITS_DETAILS}`);
    }
  };
  return (
    <div className="preference-picker-container">
      { Object.keys(preferenceOptions).map(optionKey => {
        const option = preferenceOptions[optionKey];
        return (
          <PreferenceOption
            key={optionKey}
            selected={optionKey === selected}
            onSelect={() => onSelectOption(optionKey)}
            id={optionKey}
            displayName={labels[`preferenceView_${optionKey}`]}
            iconPath={option.iconPath} />
        )
      })}
    </div>
  )
}

PreferencePicker.propTypes = {
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    preferenceView_loc: PropTypes.string.isRequired,
    preferenceView_temp: PropTypes.string.isRequired,
    preferenceView_FT: PropTypes.string.isRequired,
    preferenceView_surp: PropTypes.string.isRequired,
  }).isRequired,
};

export default PreferencePicker
